import { appConfig } from '@common/config';
import { DETAIL_STATE } from '@constants/common';
import { type GemItemType, getGemTypeString } from '@constants/gemType';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import { type IDetailIndexPorps, type IDetailItemDicInfo } from '@interface/IDetail';
import { itemInfoQueryKey } from '@network/queryKeys';
import { useDataQuery } from '@network/querys';
import { keepPreviousData } from '@tanstack/react-query';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FolderBtn } from '../FolderBtn';

export const SecSet = ({ props }: { props: IDetailIndexPorps }) => {
    const { t } = useTranslation();
    const setParams = useSetSearchParams();
    const [isFolderOepn, isFolderOepnSet] = useState(true);

    const { data: iteminfo } = useDataQuery<IDetailItemDicInfo>(
        itemInfoQueryKey,
        `/${appConfig.service}/v2.0/game/item/${props.detailId}`,
        { level: props.detailLevel },
        {
            staleTime: 5000,
            placeholderData: keepPreviousData,
            enabled: props.detailNow === DETAIL_STATE.ITEM && !!props.detailId,
        }
    );

    if (!iteminfo?.name) return null;

    const optionList = iteminfo.set.bonuses?.map((op, idx) => (
        <li key={idx}>
            <div className="key">{t('common.nseteffct').replace('{N}', op.degree.toString())}</div>
            <div className="value">
                {op.options.map((ol, idx) => (
                    <p key={idx}>{ol}</p>
                ))}
            </div>
        </li>
    ));

    const setList = iteminfo.set.items?.map((sit, idx) => {
        return (
            <p key={idx}>
                <button
                    data-detailshow={sit.id}
                    data-itemgrade={sit.grade}
                    onClick={() => {
                        const sec = document.querySelector('.gameinfo-detail__section');
                        sec && sec.scrollTo({ top: 0, behavior: 'smooth' });
                        setParams({ detail: `item_${sit.id}_${sit.level || 1}_0` });
                    }}
                >
                    {sit.name} {getGemTypeString(sit.category2 as GemItemType)}
                </button>
            </p>
        );
    });

    return (
        <section className="set" style={{ display: 'block' }}>
            <header>
                <h3>{t('common.seteffct')}</h3>
                <FolderBtn isFolderOepn={isFolderOepn} isFolderOepnSet={isFolderOepnSet} />
            </header>
            <article className={classNames({ 'is-active': isFolderOepn }, 'gameinfo-dict')}>
                <div className="gameinfo-loader">
                    <span className="loader" />
                </div>
                <ul>
                    {optionList}
                    {setList ? (
                        <li>
                            <div className="key">{t('common.setitem')}</div>
                            <div className="value">{setList}</div>
                        </li>
                    ) : (
                        <li>
                            <div className="value">없음</div>
                        </li>
                    )}
                </ul>
            </article>
        </section>
    );
};
